import React from 'react';
import {createPortal} from 'react-dom';
import {Text} from '../../styles/text';
import {modalTextColor, primaryColor} from '../../utils/variables';
import * as S from './styles';
import {ProductPickerItem} from './types';

interface Props {
    product: ProductPickerItem;
    message?: string;
}

const DetailsLoadingOverlay = ({
    product,
    message = 'Загрузка вариаций…',
}: Props) => createPortal(
    <S.DetailsLoadingOverlay>
        <S.DetailsLoadingCard>
            <S.DetailsLoadingSpinner />
            <Text extent="S" weight="bold" color={primaryColor}>
                {message}
            </Text>
            <Text extent="S" color={modalTextColor}>
                {product.name}
            </Text>
        </S.DetailsLoadingCard>
    </S.DetailsLoadingOverlay>,
    document.body,
);

export default DetailsLoadingOverlay;
